import {
  Portfolio,
  Portfolios,
  RawHistoricalIndexAsset,
  RawHistoricalIndexTimestamp,
} from 'services/price-history/interfaces'
import { ProductAssetsAnatomyData, RawProductAssetsAnatomyData } from '../product-info/model'
import Big from 'big.js'

export const filterHistoricalAssets = (
  assetsAnatomyData: RawProductAssetsAnatomyData[],
): ProductAssetsAnatomyData[] => {
  return assetsAnatomyData.map((el) => ({
    weight: Number(el.weight),
    timestamp: Number(el.timestamp),
    assets: el.indexTimestamp.assets.filter((asset) => asset.weight !== '0'),
  }))
}

export const filterAssetRanges = (assetsAnatomy: ProductAssetsAnatomyData[]) => {
  const timestampsAndRanges: ProductAssetsAnatomyData[] = []
  let lastWeights: number[] = []
  for (let i = 0; i < assetsAnatomy.length; i++) {
    if (
      assetsAnatomy[i].weight !== 0
        ? !lastWeights.includes(Number(assetsAnatomy[i].weight))
        : lastWeights.length !== assetsAnatomy[i].assets.length
    ) {
      timestampsAndRanges.push(assetsAnatomy[i])
      lastWeights = assetsAnatomy[i].assets.map((asset) => Number(asset.weight))
    }
  }
  return timestampsAndRanges
}

export function parsePortfoliosToStorage(
  response: RawHistoricalIndexAsset[],
): RawHistoricalIndexAsset {
  const chainID = response[0].chainID
  const symbol = response[0].symbol
  const id = response[0].id
  const totalSupply = response[0].totalSupply
  const history: RawHistoricalIndexTimestamp[] = []
  for (const indexHistoryPart of response) {
    for (const rawPortfolio of indexHistoryPart.history) {
      history.push(rawPortfolio)
    }
  }
  return {
    symbol,
    chainID,
    id,
    totalSupply,
    history,
  }
}

export function parseStorageToPortfolios(response: RawHistoricalIndexAsset): Portfolios[] {
  const portfolios: Portfolios[] = []
  const symbol = response.symbol
  const index = response.id
  const chainID = response.chainID
  for (const rawPortfolio of response.history) {
    const assets: Portfolio = {}
    const timestamp = Number(rawPortfolio.timestamp)
    const totalSupply = Big(rawPortfolio.totalSupply)
    for (const rawAsset of rawPortfolio.assets) {
      assets[`${rawAsset.chainID}:${rawAsset.asset}`] = {
        chainId: +rawAsset.chainID,
        value: Big(rawAsset.balance),
      }
    }
    portfolios.push({
      symbol,
      chainID,
      index,
      totalSupply,
      timestamp,
      assets,
    })
  }
  return portfolios
}
export type HistoricalIndexAssetRefresh = RawHistoricalIndexAsset & { lastUpdate: number }

export const getProductPortfolio = (symbol: string): HistoricalIndexAssetRefresh | undefined => {
  const data = localStorage.getItem(`cachedPortfolio-${symbol}`)
  const result = data !== null ? (JSON.parse(data) as HistoricalIndexAssetRefresh) : undefined

  return result
}

export const writeProductPortfolio = (
  productPortfolio: RawHistoricalIndexAsset,
  symbol: string,
  timestamp: number,
) => {
  localStorage.setItem(
    `cachedPortfolio-${symbol}`,
    JSON.stringify({ ...productPortfolio, lastUpdate: timestamp }),
  )
}
